// Cabinet trim — crown, stacking, light rail and counted trim pieces on a
// cabinet run (claude-docs/2026-10-30-venus-full-line-design.md, group 1).
module.exports = {
  ...require('./profiles'),
  ...require('./carriers'),
  ...require('./bands'),
  ...require('./fronts'),
  ...require('./pieces'),
  ...require('./ceiling'),
  ...require('./valances'),
  ...require('./drawnPieces'),
  ...require('./roomWindows'),
  ...require('./endPanels'),
};
